import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import Skeleton from '@material-ui/lab/Skeleton';
import { below } from 'utils/breakpoint';
import { componentStylePropTypes } from 'client/gameFormBased/utils/propTypes';
import EntriesList from 'client/components/Result/EntriesInfo/EntriesList';
import ResultPromoTitle from 'client/components/Result/ResultPromoTitle';

function EntriesListContainer({
    gameType,
    title,
    entriesList = [],
    hasCustomResult,
    showFullList = false,
    isLoading,
    style,
    componentStyle
}) {
    const list = showFullList ? entriesList : entriesList.slice(-1);

    return (
        <div
            css={[
                containerStyle,
                css(style, `${showFullList && !hasCustomResult ? 'min-height: 320px;' : ''}`)
            ]}
        >
            <ResultPromoTitle title={title} isLoading={isLoading} />
            {isLoading ? (
                new Array(4)
                    .fill(0)
                    .map((_, index) => <Skeleton key={index} height={30} animation="wave" />)
            ) : (
                <EntriesList items={list} gameType={gameType} componentStyle={componentStyle} />
            )}
        </div>
    );
}

EntriesListContainer.propTypes = {
    title: PropTypes.string,
    entriesList: PropTypes.array,
    showFullList: PropTypes.bool,
    isLoading: PropTypes.bool,
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    gameType: PropTypes.number,
    componentStyle: componentStylePropTypes
};

export default EntriesListContainer;

const containerStyle = css`
    padding: 24px;
    ${below('sm')} {
        padding: 16px;
    }
`;
